import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { AdminLayoutComponent } from '@referrals/shared/layouts/components/admin-layout/admin-layout.component';

const routes: Routes = [
  { path: '', redirectTo: 'capture', pathMatch: 'full' },
  {
    path: 'capture',
    loadChildren: () =>
      import('./features/initial-referral/initial-referral.module').then(
        (m) => m.InitialReferralModule
      ),
  },
  {
    path: 'callback',
    loadChildren: () =>
      import('./features/callback/callback.module').then(
        (m) => m.CallbackModule
      ),
  },
  {
    path: 'link-tracking',
    loadChildren: () =>
      import('./features/link-tracking/link-tracking.module').then(
        (m) => m.LinkTrackingModule
      ),
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./features/admin-creditors/admin-creditors.module').then(
        (m) => m.AdminCreditorsModule
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'implicit/callback',
    component: OktaCallbackComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
